/**
 * @generated SignedSource<<37a8f0b5d72f9e9bfeaaad28dcf136a8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ApprovalFilter = "AWAITING_ANY" | "AWAITING_MINE" | "HAS_ANY" | "HAS_MINE";
export type CompetitionApprovalPageQuery$variables = {
  approvalFilter?: ApprovalFilter | null | undefined;
  owner: string;
  slug: string;
  stage?: number | null | undefined;
};
export type CompetitionApprovalPageQuery$data = {
  readonly competitionBySlug: {
    readonly id: string;
    readonly title: string;
    readonly " $fragmentSpreads": FragmentRefs<"CompetitionApprovalsFragment" | "CompetitionJuryFragment">;
  } | null | undefined;
};
export type CompetitionApprovalPageQuery = {
  response: CompetitionApprovalPageQuery$data;
  variables: CompetitionApprovalPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "approvalFilter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "owner"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slug"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "stage"
},
v4 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v7 = {
  "kind": "Variable",
  "name": "approvalFilter",
  "variableName": "approvalFilter"
},
v8 = {
  "kind": "Variable",
  "name": "stage",
  "variableName": "stage"
},
v9 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v10 = [
  (v9/*:: as any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v15 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jobTitle",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
},
v16 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isEntity"
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageThumbnail",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v19 = {
  "alias": "viewerCanApprove",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "CREATE_PROJECT_VERSION_APPROVAL"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"CREATE_PROJECT_VERSION_APPROVAL\")"
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seq",
  "storageKey": null
},
v21 = [
  (v9/*:: as any*/),
  {
    "kind": "Literal",
    "name": "requiresApproval",
    "value": true
  }
],
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v23 = [
  (v22/*:: as any*/),
  (v5/*:: as any*/)
],
v24 = [
  (v7/*:: as any*/),
  (v9/*:: as any*/),
  (v8/*:: as any*/)
],
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "version",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v27 = [
  (v5/*:: as any*/),
  (v6/*:: as any*/),
  (v26/*:: as any*/)
],
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accept",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notes",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CompetitionApprovalPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*:: as any*/),
        "concreteType": "Competition",
        "kind": "LinkedField",
        "name": "competitionBySlug",
        "plural": false,
        "selections": [
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CompetitionJuryFragment"
          },
          {
            "args": [
              (v7/*:: as any*/),
              {
                "kind": "Variable",
                "name": "owner",
                "variableName": "owner"
              },
              (v8/*:: as any*/)
            ],
            "kind": "FragmentSpread",
            "name": "CompetitionApprovalsFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v0/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "CompetitionApprovalPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*:: as any*/),
        "concreteType": "Competition",
        "kind": "LinkedField",
        "name": "competitionBySlug",
        "plural": false,
        "selections": [
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          {
            "alias": "viewerCanAddJuryMember",
            "args": [
              {
                "kind": "Literal",
                "name": "action",
                "value": "ADD_COMPETITION_JURY"
              }
            ],
            "kind": "ScalarField",
            "name": "viewerCan",
            "storageKey": "viewerCan(action:\"ADD_COMPETITION_JURY\")"
          },
          {
            "alias": "viewerCanRemoveJuryMember",
            "args": [
              {
                "kind": "Literal",
                "name": "action",
                "value": "REMOVE_COMPETITION_JURY"
              }
            ],
            "kind": "ScalarField",
            "name": "viewerCan",
            "storageKey": "viewerCan(action:\"REMOVE_COMPETITION_JURY\")"
          },
          {
            "alias": null,
            "args": (v10/*:: as any*/),
            "concreteType": "CompetitionJuryConnection",
            "kind": "LinkedField",
            "name": "jury",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CompetitionJuryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  (v11/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "selectedOn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*:: as any*/),
                      (v5/*:: as any*/),
                      (v13/*:: as any*/),
                      (v14/*:: as any*/),
                      (v15/*:: as any*/),
                      (v16/*:: as any*/),
                      (v17/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v18/*:: as any*/)
            ],
            "storageKey": "jury(first:10)"
          },
          {
            "alias": null,
            "args": (v10/*:: as any*/),
            "filters": null,
            "handle": "connection",
            "key": "CompetitionJuryFragment_jury",
            "kind": "LinkedHandle",
            "name": "jury"
          },
          (v19/*:: as any*/),
          {
            "alias": "viewerCanReadPrivateApproval",
            "args": [
              {
                "kind": "Literal",
                "name": "action",
                "value": "READ_COMPETITION_PRIVATE_APPROVAL"
              }
            ],
            "kind": "ScalarField",
            "name": "viewerCan",
            "storageKey": "viewerCan(action:\"READ_COMPETITION_PRIVATE_APPROVAL\")"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasSubmissions",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CompetitionStage",
            "kind": "LinkedField",
            "name": "currentStage",
            "plural": false,
            "selections": [
              (v5/*:: as any*/),
              (v20/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v21/*:: as any*/),
            "concreteType": "CompetitionStageConnection",
            "kind": "LinkedField",
            "name": "stages",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CompetitionStageEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompetitionStage",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*:: as any*/),
                      (v20/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "validUntil",
                        "storageKey": null
                      },
                      (v12/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v11/*:: as any*/)
                ],
                "storageKey": null
              },
              (v18/*:: as any*/)
            ],
            "storageKey": "stages(first:10,requiresApproval:true)"
          },
          {
            "alias": null,
            "args": (v21/*:: as any*/),
            "filters": [
              "hasLeaderboard",
              "requiresApproval"
            ],
            "handle": "connection",
            "key": "CompetitionStageSelectFragment_stages",
            "kind": "LinkedHandle",
            "name": "stages"
          },
          (v22/*:: as any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "slug",
                "variableName": "owner"
              }
            ],
            "concreteType": "EventCompetition",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "event",
                "plural": false,
                "selections": (v23/*:: as any*/),
                "storageKey": null
              },
              (v5/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v24/*:: as any*/),
            "concreteType": "SubmissionConnection",
            "kind": "LinkedField",
            "name": "submissions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SubmissionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Submission",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "entity",
                        "plural": false,
                        "selections": [
                          (v12/*:: as any*/),
                          (v13/*:: as any*/),
                          (v16/*:: as any*/),
                          (v14/*:: as any*/),
                          (v17/*:: as any*/),
                          (v5/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CompetitionStage",
                        "kind": "LinkedField",
                        "name": "stage",
                        "plural": false,
                        "selections": [
                          (v20/*:: as any*/),
                          (v5/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 5
                          }
                        ],
                        "concreteType": "SubmissionWorkspaceVersionConnection",
                        "kind": "LinkedField",
                        "name": "workspaceVersions",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WorkspaceVersion",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                              (v5/*:: as any*/),
                              (v25/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Workspace",
                                "kind": "LinkedField",
                                "name": "workspace",
                                "plural": false,
                                "selections": (v23/*:: as any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "workspaceVersions(first:5)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectVersion",
                        "kind": "LinkedField",
                        "name": "latest",
                        "plural": false,
                        "selections": [
                          (v5/*:: as any*/),
                          (v25/*:: as any*/),
                          {
                            "alias": "viewerCanReadFiles",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "action",
                                "value": "READ_PROJECT_VERSION_FILE"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "viewerCan",
                            "storageKey": "viewerCan(action:\"READ_PROJECT_VERSION_FILE\")"
                          },
                          {
                            "alias": "approvalsCheck",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 2
                              }
                            ],
                            "concreteType": "ProjectVersionApprovalConnection",
                            "kind": "LinkedField",
                            "name": "approvals",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectVersionApproval",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": "viewerCanRead",
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "action",
                                        "value": "READ_PROJECT_VERSION_APPROVAL"
                                      }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "viewerCan",
                                    "storageKey": "viewerCan(action:\"READ_PROJECT_VERSION_APPROVAL\")"
                                  },
                                  (v5/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "approvals(first:2)"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectVersionEvaluation",
                            "kind": "LinkedField",
                            "name": "evaluation",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "score",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "error",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "finalizedAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "max",
                                "storageKey": null
                              },
                              (v5/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v12/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CompetitionStage",
                                "kind": "LinkedField",
                                "name": "stage",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "showMetric",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "noCode",
                                    "storageKey": null
                                  },
                                  (v5/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CompetitionScoringCriterion",
                                    "kind": "LinkedField",
                                    "name": "scoringCriteria",
                                    "plural": true,
                                    "selections": (v27/*:: as any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v5/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "entity",
                            "plural": false,
                            "selections": [
                              (v12/*:: as any*/),
                              (v14/*:: as any*/),
                              (v13/*:: as any*/),
                              (v5/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectVersionApproval",
                            "kind": "LinkedField",
                            "name": "approval",
                            "plural": false,
                            "selections": [
                              (v12/*:: as any*/),
                              (v5/*:: as any*/),
                              (v28/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectVersionApprovalScore",
                                "kind": "LinkedField",
                                "name": "scores",
                                "plural": true,
                                "selections": [
                                  (v5/*:: as any*/),
                                  (v29/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CompetitionScoringCriterion",
                                    "kind": "LinkedField",
                                    "name": "competitionScoringCriterion",
                                    "plural": false,
                                    "selections": [
                                      (v5/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v30/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v19/*:: as any*/),
                          {
                            "alias": null,
                            "args": (v10/*:: as any*/),
                            "concreteType": "ProjectVersionApprovalConnection",
                            "kind": "LinkedField",
                            "name": "approvals",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectVersionApprovalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  (v11/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProjectVersionApproval",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v28/*:: as any*/),
                                      (v30/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProjectVersionApprovalScore",
                                        "kind": "LinkedField",
                                        "name": "scores",
                                        "plural": true,
                                        "selections": [
                                          (v5/*:: as any*/),
                                          (v29/*:: as any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CompetitionScoringCriterion",
                                            "kind": "LinkedField",
                                            "name": "competitionScoringCriterion",
                                            "plural": false,
                                            "selections": (v27/*:: as any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "entity",
                                        "plural": false,
                                        "selections": [
                                          (v12/*:: as any*/),
                                          (v13/*:: as any*/),
                                          (v14/*:: as any*/),
                                          (v15/*:: as any*/),
                                          (v16/*:: as any*/),
                                          (v17/*:: as any*/),
                                          (v5/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v5/*:: as any*/),
                                      (v12/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v18/*:: as any*/)
                            ],
                            "storageKey": "approvals(first:10)"
                          },
                          {
                            "alias": null,
                            "args": (v10/*:: as any*/),
                            "filters": null,
                            "handle": "connection",
                            "key": "SubmissionApprovalsFragment_approvals",
                            "kind": "LinkedHandle",
                            "name": "approvals"
                          }
                        ],
                        "storageKey": null
                      },
                      (v12/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v11/*:: as any*/)
                ],
                "storageKey": null
              },
              (v18/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v24/*:: as any*/),
            "filters": [
              "approvalFilter",
              "stage"
            ],
            "handle": "connection",
            "key": "CompetitionApprovalsFragment_submissions",
            "kind": "LinkedHandle",
            "name": "submissions"
          },
          {
            "alias": null,
            "args": [
              (v8/*:: as any*/)
            ],
            "concreteType": "CompetitionStage",
            "kind": "LinkedField",
            "name": "stage",
            "plural": false,
            "selections": [
              (v20/*:: as any*/),
              {
                "alias": "viewerCanEdit",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "action",
                    "value": "UPDATE_COMPETITION_STAGE"
                  }
                ],
                "kind": "ScalarField",
                "name": "viewerCan",
                "storageKey": "viewerCan(action:\"UPDATE_COMPETITION_STAGE\")"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CompetitionScoringCriterion",
                "kind": "LinkedField",
                "name": "scoringCriteria",
                "plural": true,
                "selections": [
                  (v5/*:: as any*/),
                  (v6/*:: as any*/),
                  (v26/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "weight",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c45e04e42a7c4dc5443a16ec32168887",
    "id": null,
    "metadata": {},
    "name": "CompetitionApprovalPageQuery",
    "operationKind": "query",
    "text": "query CompetitionApprovalPageQuery(\n  $owner: String!\n  $slug: String!\n  $approvalFilter: ApprovalFilter\n  $stage: Int\n) {\n  competitionBySlug(slug: $slug) {\n    id\n    title\n    ...CompetitionJuryFragment\n    ...CompetitionApprovalsFragment_1yXj7p\n  }\n}\n\nfragment BaseProjectVersionApprovalButtonFragment on ProjectVersion {\n  id\n  version\n  entity {\n    __typename\n    displayName\n    username\n    id\n  }\n  approval {\n    __typename\n    id\n    accept\n    scores {\n      id\n      value\n      competitionScoringCriterion {\n        id\n      }\n    }\n    notes\n  }\n  project {\n    __typename\n    id\n    stage {\n      id\n      scoringCriteria {\n        id\n        title\n        description\n      }\n    }\n  }\n  viewerCanApprove: viewerCan(action: CREATE_PROJECT_VERSION_APPROVAL)\n  ...SubmissionStatusBadgeFragment\n}\n\nfragment CompetitionApprovalsFragment_1yXj7p on Competition {\n  viewerCanApprove: viewerCan(action: CREATE_PROJECT_VERSION_APPROVAL)\n  viewerCanReadPrivateApproval: viewerCan(action: READ_COMPETITION_PRIVATE_APPROVAL)\n  hasSubmissions\n  ...FiltersForCompetitionApprovalsFragment\n  ...SubmissionsCompetitionApprovalsFragment_1yXj7p\n  ...CompetitionScoringCriteriaFragment_1X6Izt\n}\n\nfragment CompetitionJuryFragment on Competition {\n  viewerCanAddJuryMember: viewerCan(action: ADD_COMPETITION_JURY)\n  viewerCanRemoveJuryMember: viewerCan(action: REMOVE_COMPETITION_JURY)\n  jury(first: 10) {\n    edges {\n      cursor\n      selectedOn\n      node {\n        __typename\n        id\n        username\n        displayName\n        ... on User {\n          jobTitle\n        }\n        ...EntityProfilePicFragment_49kWkb\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment CompetitionScoringCriteriaFragment_1X6Izt on Competition {\n  slug\n  event(slug: $owner) {\n    event {\n      slug\n      id\n    }\n    id\n  }\n  stage(stage: $stage) {\n    seq\n    viewerCanEdit: viewerCan(action: UPDATE_COMPETITION_STAGE)\n    scoringCriteria {\n      id\n      title\n      description\n      weight\n    }\n    id\n  }\n  id\n}\n\nfragment CompetitionStageSelectFragment_2ekORf on Competition {\n  currentStage {\n    id\n    seq\n  }\n  stages(first: 10, requiresApproval: true) {\n    edges {\n      node {\n        id\n        seq\n        validUntil\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment EntityProfilePicFragment_49kWkb on Entity {\n  __isEntity: __typename\n  displayName\n  imageThumbnail\n}\n\nfragment FiltersForCompetitionApprovalsFragment on Competition {\n  viewerCanApprove: viewerCan(action: CREATE_PROJECT_VERSION_APPROVAL)\n  ...CompetitionStageSelectFragment_2ekORf\n}\n\nfragment SubmissionApprovalsFragment on ProjectVersion {\n  entity {\n    __typename\n    username\n    displayName\n    id\n  }\n  approvals(first: 10) @ifAllowed {\n    edges {\n      cursor\n      node {\n        accept\n        notes\n        scores {\n          id\n          value\n          competitionScoringCriterion {\n            id\n            title\n            description\n          }\n        }\n        entity {\n          __typename\n          username\n          displayName\n          ... on User {\n            jobTitle\n          }\n          ...EntityProfilePicFragment_49kWkb\n          id\n        }\n        id\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment SubmissionStatusBadgeFragment on ProjectVersion {\n  id\n  status\n  version\n  evaluation {\n    score\n    error\n    finalizedAt\n    max\n    id\n  }\n  project {\n    __typename\n    stage {\n      showMetric\n      noCode\n      id\n    }\n    id\n  }\n}\n\nfragment SubmissionsCompetitionApprovalsFragment_1yXj7p on Competition {\n  slug\n  event(slug: $owner) {\n    event {\n      slug\n      id\n    }\n    id\n  }\n  viewerCanApprove: viewerCan(action: CREATE_PROJECT_VERSION_APPROVAL)\n  submissions(approvalFilter: $approvalFilter, first: 10, stage: $stage) {\n    edges {\n      node {\n        id\n        entity {\n          __typename\n          username\n          ...EntityProfilePicFragment_49kWkb\n          id\n        }\n        stage {\n          seq\n          id\n        }\n        workspaceVersions(first: 5) @ifAllowed {\n          nodes {\n            id\n            version\n            workspace {\n              slug\n              id\n            }\n          }\n        }\n        latest {\n          id\n          version\n          viewerCanReadFiles: viewerCan(action: READ_PROJECT_VERSION_FILE)\n          approvalsCheck: approvals(first: 2) @ifAllowed {\n            nodes {\n              viewerCanRead: viewerCan(action: READ_PROJECT_VERSION_APPROVAL)\n              id\n            }\n          }\n          ...SubmissionStatusBadgeFragment\n          ...BaseProjectVersionApprovalButtonFragment\n          ...SubmissionApprovalsFragment\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "d82bda966d4f9d9819a1ccb3b337630f";

export default node;
